// extracted by mini-css-extract-plugin
export var addButton = "_og-0";
export var border = "_og-8";
export var check = "_og-h";
export var danger = "_og-6";
export var dropdownContainer = "_og-1";
export var editModalBody = "_og-j";
export var footerContainer = "_og-i";
export var fullWidth = "_og-a";
export var hide = "_og-9";
export var icon = "_og-3";
export var input = "_og-7";
export var inputFlex = "_og-b";
export var inputWrapper = "_og-c";
export var manualFocus = "_og-5";
export var optionButton = "_og-4";
export var pillWrapper = "_og-e";
export var pointer = "_og-2";
export var showOverflow = "_og-f";
export var tagsFlex = "_og-d";
export var xButton = "_og-g";